import React from 'react';
import PropTypes from 'prop-types';

// @material-ui
import { Grid } from '@material-ui/core';

// core
import { useGlobal } from '_core/hooks/useGlobal';
import { withLang } from '_core/hocs/withLang';
import { withVisitorInfo } from '_core/utils/visitorInfo';
import { Loading } from '_core/components/Loading';
import { TextInput } from '_core/components/TextInput';


const RawProfileOrgInfo = (props) => {
  const { visitorInfo, getLangString: l } = props
  
  const {
    request: { queue },
  } = useGlobal();
  
  const [data, setData] = React.useState(null);
  
  React.useEffect(() => {
    if (visitorInfo && !visitorInfo.isLoading && visitorInfo.info.is_organization) {
      queue('auth/org/info', {})
        .then((data) => setData(data))
        .catch((error) => null);
    }
  }, [visitorInfo?.isLoading, visitorInfo.info?.is_organization]);
  
  if (!data)
    return <Loading progressType="linear" />;
  
  return (
    <Grid container={true}>
      <Grid item={true} xs={12}>
        <TextInput readonly value={data.name} label={l('global.field.name')} helperText="" />
      </Grid>
      
      <Grid item={true} xs={12} md={6}>
        <TextInput readonly value={data.inn} label={l('global.field.inn')} helperText="" />
      </Grid>
      
      <Grid item={true} xs={12} md={6}>
        <TextInput readonly value={data.kpp} label={l('global.field.kpp')} helperText="" />
      </Grid>
      
      <Grid item={true} xs={12} md={6}>
        <TextInput readonly value={data.email} label={l('global.field.email')} helperText="" />
      </Grid>
      
      <Grid item={true} xs={12} md={6}>
        <TextInput readonly value={data.phone} label={l('global.field.phone')} helperText="" />
      </Grid>
    </Grid>
  );
};

RawProfileOrgInfo.defaultProps = {};

RawProfileOrgInfo.propTypes = {
  // withVisitorInfo
  visitorInfo: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
};

export const ProfileOrgInfo = withVisitorInfo(withLang(RawProfileOrgInfo));

ProfileOrgInfo.getVisibility = (props) => {
  const { visitorInfo } = props;
  
  if (!visitorInfo || visitorInfo?.isLoading)
    return 'loading';
  
  if (!visitorInfo.info.is_organization)
    return 'hidden';
  
  return 'visible';
};
